"use client";

import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import {ChevronDown} from "lucide-react";

import {cn} from "@/lib/utils";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({className, ...props}, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn("border-b", className)}
    {...props}
  />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
>(({className, children, ...props}, ref) => (
  <AccordionPrimitive.Header className="flex data-[state=closed]:hover:bg-muted transition-colors">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "flex flex-1 p-5 text-base items-center font-medium transition-all [&[data-state=open]>.chevron]:rotate-180",
        className,
      )}
      {...props}
    >
      {children}
      <ChevronDown className="chevron h-5 w-5 shrink-0 transition-transform duration-200 ml-auto" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content> & {
    parentClassName?: string;
  }
>(({className, children, parentClassName, ...props}, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className={cn(
      "accordionContent text-sm transition-all relative",
      parentClassName,
    )}
    {...props}
  >
    <div className={cn("pb-3 px-5 text-sm", className)}>{children}</div>
  </AccordionPrimitive.Content>
));

AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export {Accordion, AccordionItem, AccordionTrigger, AccordionContent};
